import { SlidersHorizontal } from 'lucide-react';
import { Button, Slide, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import styles from './SettingsButton.module.css';

interface Props {
  className?: string;
  onClick: () => void;
}

export const SettingsButton = ({ className, onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={`${styles.container} ${className ?? ''}`}>
      <Tooltip title={t('developerSettings')} arrow>
        <span>
          <Button variant="text" onClick={onClick} sx={{ minWidth: 'auto', padding: '8px' }}>
            <SlidersHorizontal size={22} />
          </Button>
        </span>
      </Tooltip>
    </div>
  );
};
